//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "./template/siteMapsTemplate.html"], function (Marionette, SiteMapsTemplate) {
  var SiteMapsView = {};

  SiteMapsView.siteMapsView = Marionette.Layout.extend({
    template: SiteMapsTemplate,
    triggers: {
      "click #addSiteMap": "add:siteMap",
    },
    regions: {
      siteMapItem: "#siteMapItem",
      siteMapList: "#siteMapList",
    },
  });

  return SiteMapsView;
});
